import React from "react";
import { Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { apiErrorToast } from "Utils";
import { useDetachPackageMutation } from "../../services/projects.api";

type DetachFromCatalogProps = {
  isOpen: boolean;
  packageId: string;
  packageName: string;
  catalogName: string;
  onClose: () => void;
};

const DetachFromCatalog = ({
  isOpen,
  packageId,
  packageName,
  catalogName,
  onClose,
}: DetachFromCatalogProps): React.JSX.Element => {
  const [detachPackage] = useDetachPackageMutation();

  const handleDetach = async (): Promise<void> => {
    try {
      await detachPackage({ packageId }).unwrap();

      Toast.show({
        title: (
          <>
            <strong>{packageName}</strong> detached from {catalogName} catalog
          </>
        ),
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not detach package");
    }

    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      title={
        <>
          Detach from <em>{catalogName}</em> catalog?
        </>
      }
      subtitle={packageName}
      confirmText="Detach"
      confirmButtonColor="error"
      cancelButtonColor="primary"
      onConfirm={handleDetach}
      onCancel={onClose}
      onClose={onClose}
      dangerZone={packageName}
    >
      <p>
        The <em>{packageName}</em> package keeps its imported versions. New
        versions are no longer synced from the <em>{catalogName}</em> catalog,
        and manual uploads are allowed again.
      </p>
    </Dialog>
  );
};

export default DetachFromCatalog;
